import { asyncMac, makeAsyncTypes } from "../utils";
import { toast } from 'react-toastify';
import { PIEZAS_API } from "../../views/MainLayout/components/shared/services/piezas";

const initialPieza = null;

export const piezaReducer = (state = initialPieza, action) => {
    switch(action.type){
        case "pieza/fullfilled": {
            return action.payload;
        }
        case "pieza/servicio_envio": {
            if(action.payload.transportista_id === 1) {
                return {
                    ...state,
                    precio_transporte: action.payload.precio_transporte,
                    servicio_envio: action.payload
                }
            } else {
                return {
                    ...state,
                    servicio_envio: action.payload
                }
            }
        }
        case "pieza/servicio_envio_precio": {
            const newPieza = action.payload;
            newPieza.servicio_envio = state.servicio_envio;
            newPieza.servicio_envio.precio_transporte = action.payload.precio_transporte;

            return newPieza;
        }
        case "pieza/clear": {
            return initialPieza;
        }
        default:
            return state
    }
}

const asyncPieza = makeAsyncTypes('pieza');

const [setPending, setFullFilled, setError ] = asyncMac(asyncPieza);

export const savePieza = (pieza) => async dispatch => {
    dispatch(setPending());

    try {
        const response = await PIEZAS_API.new(pieza)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilled(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        toast.error(e.message)
        dispatch(setError(e.message))
    }
}

export const editPieza = (pieza) => async dispatch => {
    dispatch(setPending());

    try {
        const response = await PIEZAS_API.update(pieza)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilled(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        toast.error(e.message)
        dispatch(setError(e.message))
    }
}

export const currentPiezaReducer = piezaReducer;